module.exports = __webpack_public_path__ + "static/case7_534-352da332377c732e87e4d8889d228126.jpeg";